import { Button } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import React, { useState, useEffect } from 'react';
import {
  GUEST_ROOM_EXPERIENCE_GLOBAL,
  GUEST_ROOM_EXPERIENCE_ROOM,
  GUEST_ROOM_EXPERIENCE_TEMPLATE,
} from '../../../../../constants/GuestRoomExperienceConst';
import './Guest-Room-Experience.scss';
import { makeStyles } from '@material-ui/core/styles';
import GuestRoomExperienceGlobal from './guest-room-experience-global/Guest-Room-Experience-Global';
import GuestRoomExperienceTemplate from './guest-room-experience-template/Guest-Room-Experience-Template';
import GuestRoomExperienceRoom from './guest-room-experience-room/Guest-Room-Experience-Room';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { selectedHotelSelector } from '../../../../property/propertySlice';
import { fetchGRERoomList, fetchGRETemplates, fetchVendors } from '../../../configurationSlice';
import GuestRoomExperienceTemplateView from './guest-room-experience-template/template-view/Template-View';
import GuestRoomExperienceRoomView from './guest-room-experience-room/guest-room-experience-room-view/Guest-Room-Experience-Room-View';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    minWidth: '170px',
    fontWeight: 500,
  },
  button: {
    borderRadius: '26px',
    minWidth: '170px',
    fontWeight: 500,
  },
  input: {
    display: 'none',
  },
}));

const GuestRoomExperience = (props) => {
  const { showLoader = () => {} } = props;
  const [activeTab, setActiveTab] = useState(GUEST_ROOM_EXPERIENCE_GLOBAL);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const selectedHotel = useSelector(selectedHotelSelector);
  const [viewState, setViewState] = useState({
    status: false,
    isTemplate: true,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const onViewToggleTemplate = (status, isTemplate, template) => {
    // For Room/Template-View
    setViewState({
      status: status,
      isTemplate: isTemplate,
      template: template,
    });
  };

  const handleActiveTab = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (
      activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL ||
      activeTab === GUEST_ROOM_EXPERIENCE_TEMPLATE ||
      activeTab === GUEST_ROOM_EXPERIENCE_ROOM
    ) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchGRERoomList(selectedHotel));
      dispatch(fetchGRETemplates(selectedHotel));
      dispatch(fetchVendors(selectedHotel));
    }
  }, [history, selectedHotel, dispatch]);

  return (
    <div className='container mt-4 detail-view pb-6'>
      {selectedHotel && viewState.isTemplate && viewState.status && (
        <GuestRoomExperienceTemplateView
          template={viewState.template}
          onViewToggle={onViewToggleTemplate}
          onBack={handleActiveTab}
          showLoader={showLoader}
        />
      )}
      {selectedHotel && !viewState.isTemplate && viewState.status && (
        <GuestRoomExperienceRoomView
          room={viewState.template}
          onViewToggle={onViewToggleTemplate}
          onBack={handleActiveTab}
          showLoader={showLoader}
        />
      )}
      {!viewState.status && (
        <>
          <div className='mt-5 row mx-0'>
            <div className='col col-md-6 px-0 d-flex align-items-center'>
              <span className='page-title'>Guest Room Experience</span>
            </div>
          </div>
          <div className='row d-flex mt-4 guest-room-list'>
            <div className='d-flex gap-3 flex-wrap'>
              <Button
                size='large'
                variant={activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL ? 'outlined' : 'text'}
                className={
                  activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL ? classes.activeButton : classes.button
                }
                onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_GLOBAL)}
              >
                Global
              </Button>
              <Button
                size='large'
                variant={activeTab === GUEST_ROOM_EXPERIENCE_TEMPLATE ? 'outlined' : 'text'}
                className={
                  activeTab === GUEST_ROOM_EXPERIENCE_TEMPLATE
                    ? classes.activeButton
                    : classes.button
                }
                onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_TEMPLATE)}
              >
                Template
              </Button>
              <Button
                size='large'
                variant={activeTab === GUEST_ROOM_EXPERIENCE_ROOM ? 'outlined' : 'text'}
                className={
                  activeTab === GUEST_ROOM_EXPERIENCE_ROOM ? classes.activeButton : classes.button
                }
                onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_ROOM)}
              >
                Room
              </Button>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow detail-view-65'>
              {activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL && (
                <GuestRoomExperienceGlobal showLoader={showLoader} />
              )}
              {activeTab === GUEST_ROOM_EXPERIENCE_TEMPLATE && (
                <GuestRoomExperienceTemplate
                  onViewToggleTemplate={onViewToggleTemplate}
                  showLoader={showLoader}
                />
              )}
              {activeTab === GUEST_ROOM_EXPERIENCE_ROOM && (
                <GuestRoomExperienceRoom
                  onViewToggleTemplate={onViewToggleTemplate}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  showLoader={showLoader}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GuestRoomExperience;
